import { getCurrentInstance } from 'vue'
import { getAppGlobals } from '@/plugins/appGlobals';
import professionalProfile from '@js/professionalProfile';

export default function useAuth() {
  const app = getAppGlobals();

  async function refreshLogin() {
    if ( app.$Session.get(app.$userSessionName).login){
        const response = await app.$axios.post("api/account/login", {login: app.$Session.get(app.$userSessionName).login, password: app.$Session.get(app.$userSessionName).password});
        storeSessionData(response.data)
        return response.data
    }
  }

  function storeSessionData(data) {
    let profile = professionalProfile(data.Token.Value)
    app.$Session.set(app.$userSessionName, {
      token: data.Token,
      login: app.$Session.get(app.$userSessionName).login,
      password: app.$Session.get(app.$userSessionName).password,
      doctor: data.Professional ? data.Professional.Doctor : data.Doctor,
      professional: data.Professional ? data.Professional : null,
      profile,
      isTrial: data.Professional.IsTrial,
      trial: data.Professional.TrialRemainingDays,
    })
  }

  return { refreshLogin }
}
